/** 預估用完區間大數字：字體樣式（DEV 可切換比較） */
export type IntervalRangeFontKey = "default" | "condensed" | "bebas";

export const INTERVAL_RANGE_FONT_OPTIONS: { key: IntervalRangeFontKey; label: string; desc: string }[] = [
  { key: "default", label: "預設", desc: "Fredoka（hero 大數字）" },
  { key: "condensed", label: "海報・窄體", desc: "Barlow Condensed 800" },
  { key: "bebas", label: "海報・Bebas", desc: "Bebas Neue 展示體" },
];

export const intervalRangeFontStyle = (
  key: IntervalRangeFontKey,
): { fontFamily: string; fontWeight: number; letterSpacing: string; fontSizeScale: number } => {
  switch (key) {
    case "condensed":
      return {
        fontFamily: "'Barlow Condensed', 'Noto Sans TC', sans-serif",
        fontWeight: 800,
        letterSpacing: "0.03em",
        fontSizeScale: 1.08,
      };
    case "bebas":
      return {
        fontFamily: "'Bebas Neue', 'Noto Sans TC', sans-serif",
        fontWeight: 400,
        letterSpacing: "0.06em",
        fontSizeScale: 1.18,
      };
    default:
      return {
        // 與另外兩個 hero 的大數字同一套字（見 HomePage/homeSkin.ts 的 DAY_NUMBER_FONT）
        fontFamily: "'Fredoka', var(--font-sans)",
        fontWeight: 600,
        letterSpacing: "-0.01em",
        fontSizeScale: 1,
      };
  }
};
